<template>
  <div>
    <div class="col-mr-5 mt-3">
      <right-panel class="float-right" id="sidebar-new-direct-collect-method" width="800px" :icon="'mdi mdi-plus'" :text="$t('direct-collect-method.new')">
        <div class="pl-5 pr-5">
          <FormDirectCollectMethod :inventory="true" :hide-library="true" />
        </div>
      </right-panel>
    </div>

    <h6>{{ $t("direct-collect-method.text") }}</h6>

    <LibraryItems
      rightPanelId="sidebar-new-datasource-direct-collect-method"
      organizationScopedState="datasourceDirectCollectMethod"
      libraryScopedState="directCollectMethod"
      :hideCategoryFilter="true"
      :hideSaveAs="true"
      @interceptForSetParent="interceptForSetParent"
    />
  </div>
</template>

<script>
import LibraryItems from "@cc/library-items";
import FormDirectCollectMethod from "@modules/collect-method/workspace-library-direct-collect-method-form";

export default {
  props: ["hide-library"],
  components: {
    LibraryItems,
    FormDirectCollectMethod,
  },
  data() {
    return {
      form: { name: undefined },
      formError: undefined,
      entityName: undefined,
    };
  },

  computed: {
    isUpdating() {
      return this.$store.getters["datasourceDirectCollectMethod/isUpdating"];
    },
    //

    editedDatasource() {
      return this.$store.getters["datasourceDirectCollectMethod/editedDatasource"];
    },
  },
  mounted() {},
  methods: {
    cancel() {
      this.$store.dispatch("datasourceDirectCollectMethod/resetForm");
    },

    interceptForSetParent(payload) {
      payload.datasource = this.editedDatasource;
    },
  },
};
</script>
